import K from '../constants/MenuConstants';

const init = {
    topMenu: {
        hidden: true,
        items: [
            {
                label: 'Inicio',
                link: '/'
            },
            {
                label: 'Haz tu Cita',
                link: '/citas'
            },
            {
                label: 'Contacto',
                link: '/contacto'
            }
        ]
    },
    leftMenu: {
        hidden: false,
        items: [
            {
                label: 'Benito Santos',
                link: '/bio'
            }
        ]
    },
    rightMenu: {
        hidden: false,
        items: [
            {
                label: 'Celebridades',
                link: '/celebridades'
            },
            {
                label: 'Prensa',
                link: '/prensa'
            },
            {
                label: 'Haz tu Cita',
                link: '/citas'
            },
            {
                label: 'Contacto',
                link: '/contacto'
            }
        ]
    },
    tailormadeMenu: {
        hidden: true,
        items: [
            {
                label: 'Campaña',
                link: '/colecciones/tailormade/campana'
            },
            {
                label: 'Lookbook',
                link: '/colecciones/tailormade/lookbook'
            }
        ]
    },
    bridesMenu: {
        hidden: true,
        items: [
            {
                label: 'Campaña',
                link: '/colecciones/novias/campana'
            },
            {
                label: 'Lookbook',
                link: '/colecciones/novias/lookbook'
            }
        ]
    },
    bsMenu: {
        hidden: true,
        items: [
            {
                label: 'Campaña',
                link: '/colecciones/bs/campana'
            },
            {
                label: 'Lookbook',
                link: '/colecciones/bs/lookbook'
            }
        ]
    }
};

export default function reducer(state = init, action) {
    switch (action.type) {
        case K.MENU_TOP_HIDE:
            return {
                ...state,
                topMenu: { ...state.topMenu, hidden: true }
            };
        case K.MENU_TOP_SHOW:
            return {
                ...state,
                topMenu: { ...state.topMenu, hidden: false }
            };
        case K.MENU_LEFT_HIDE:
            return {
                ...state,
                leftMenu: { ...state.leftMenu, hidden: true }
            };
        case K.MENU_LEFT_SHOW:
            return {
                ...state,
                leftMenu: { ...state.leftMenu, hidden: false }
            };
        case K.MENU_TAILORMADE_HIDE:
            return {
                ...state,
                tailormadeMenu: { ...state.tailormadeMenu, hidden: true }
            };
        case K.MENU_TAILORMADE_SHOW:
            return {
                ...state,
                tailormadeMenu: { ...state.tailormadeMenu, hidden: false }
            };
        case K.MENU_BRIDES_HIDE:
            return {
                ...state,
                bridesMenu: { ...state.bridesMenu, hidden: true }
            };
        case K.MENU_BRIDES_SHOW:
            return {
                ...state,
                bridesMenu: { ...state.bridesMenu, hidden: false }
            };
        case K.MENU_BS_HIDE:
            return {
                ...state,
                bsMenu: { ...state.bsMenu, hidden: true }
            };
        case K.MENU_BS_SHOW:
            return {
                ...state,
                bsMenu: { ...state.bsMenu, hidden: false }
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/MenuReducer.js